export enum PlayErrorCodes {
  NoParamsFound = 'NoParamsFound',
  InvalidDeviceId = 'InvalidDeviceId',
  InvalidGeniallyUserId = 'InvalidGeniallyUserId',
  InvalidTeamId = 'InvalidTeamId',
  InvalidUsername = 'InvalidUsername',
  InvalidGeniallyId = 'InvalidGeniallyId',
  InvalidType = 'InvalidType',
  InvalidSessionId = 'InvalidSessionId',
  InvalidCookie = 'InvalidCookie',
  InvalidGameVersion = 'InvalidGameVersion',
  CannotReplaceHost = 'CannotReplaceHost',
  SessionIdInUse = 'SessionIdInUse',
  UsernameInUse = 'UsernameInUse',
}

export const isValidPlayErrorCode = (payload: unknown): payload is PlayErrorCodes => {
  if (typeof payload !== 'string') {
    return false;
  }

  return Object.values(PlayErrorCodes).includes(payload as any);
};

export enum PlayServerDisconnectReason {
  HostReplaced = 'host-replaced',
}

export const isValidPlayServerDisconnectReason = (
  reason: unknown,
): reason is PlayServerDisconnectReason =>
  typeof reason === 'string' &&
  Object.values(PlayServerDisconnectReason).includes(reason as any);

export type PlayWebsocketServerToClientMessage = never;
